import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const uploadStatusManager = {
  uploadStatus(params: any, url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET',
      data: params
    });
  }
};

export default uploadStatusManager;
